const errorHandle = () => {}

export default errorHandle
